import React from "react";
import { useParams, Navigate } from "react-router-dom";
import SessionReportsBoard from "views/admin/reports/SessionReportsBoard";

const CenterSessionReports = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return <SessionReportsBoard centerId={centerId} />;
};

export default CenterSessionReports;
